import axios from "axios";

const normalizeBase = (value) => String(value || "").trim().replace(/\/+$/, "");
const API_BASE = normalizeBase(import.meta.env.VITE_API_BASE_URL || "");

async function request(method, path, data) {
  const response = await axios({
    method,
    url: `${API_BASE}${path}`,
    data,
    timeout: 120000,
    validateStatus: (status) => status >= 200 && status < 500,
  });

  if (response.status >= 400) {
    throw new Error(response?.data?.message || response?.data?.error || `Erro HTTP ${response.status}`);
  }

  const payload = response.data || {};
  if (payload.ok === false) {
    throw new Error(payload.message || "Erro ao processar solicitação.");
  }

  return payload.data ?? payload;
}

const buildQuery = (params = {}) => {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && String(value).trim() !== "") {
      search.set(key, String(value).trim());
    }
  });
  const qs = search.toString();
  return qs ? `?${qs}` : "";
};

export const fetchCashFlowAnalysis = (params = {}) =>
  request("get", `/api/comercial/fluxo-caixa${buildQuery(params)}`);

export const fetchReceivableDelinquencyAnalysis = (params = {}) =>
  request("get", `/api/comercial/inadimplencia-analise${buildQuery(params)}`);

export const fetchCollectionWorkflow = (params = {}) =>
  request("get", `/api/inadimplencia${buildQuery(params)}`);

export const saveCollectionCase = (payload) =>
  request(payload?.id ? "put" : "post", `/api/inadimplencia/cases${payload?.id ? `/${payload.id}` : ""}`, payload);

export const deleteCollectionCase = (id) =>
  request("delete", `/api/inadimplencia/cases/${id}`);

export const sendCollectionDailyReport = (payload) =>
  request("post", "/api/inadimplencia/reports/whatsapp", payload);

export const fetchDelinquencyClientDetails = (params = {}) =>
  request("get", `/api/comercial/inadimplencia-cliente${buildQuery(params)}`);

export const addCollectionContact = (id, payload) =>
  request("post", `/api/inadimplencia/cases/${id}/contacts`, payload);

export const registerCollectionPayment = (id, payload) =>
  request("post", `/api/inadimplencia/cases/${id}/payments`, payload);
